// anvar-masuma-preview — Anvar & Ma'suma wedding card (w28).
//
// Deep-ink wedding: gold foil border around a midnight-paper inner card.
// A round photo medallion with a gold ring takes centre, framed by gold
// constellation flourishes at top + bottom. "TO'Y MAROSIMI" eyebrow in
// roman small-caps; Cinzel names in champagne-gold ink; gold small-cap
// caption. Colours resolve from LayoutCtx.
import { Photo, type LayoutCtx } from "./_shared";

export function AnvarMasumaPreviewLayout({
  names,
  date,
  venue,
  accent,
  ink,
  bg,
  font,
  photo,
}: LayoutCtx) {
  const FOIL = `linear-gradient(135deg, ${accent} 0%, ${accent}cc 22%, ${accent} 45%, ${accent}cc 70%, ${accent} 100%)`;
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: FOIL,
        padding: "5%",
        display: "flex",
      }}
    >
      <div
        style={{
          flex: 1,
          background: bg,
          color: ink,
          position: "relative",
          padding: "8%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          boxShadow: `inset 0 0 0 1px ${accent}55, inset 0 0 0 5px ${bg}, inset 0 0 0 6px ${accent}55`,
        }}
      >
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 7,
            fontWeight: 700,
            letterSpacing: "0.4em",
            color: accent,
            marginBottom: "5%",
          }}
        >
          TO&apos;Y MAROSIMI
        </div>

        {/* Gold-ringed photo medallion */}
        <div style={{ width: "62%", aspectRatio: "1 / 1", position: "relative", marginBottom: "5%" }}>
          <div
            style={{
              position: "absolute",
              inset: 0,
              borderRadius: "50%",
              background: FOIL,
              padding: "5%",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                background: bg,
                padding: "4%",
                boxSizing: "border-box",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "50%",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <Photo
                  src={photo}
                  style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }}
                  fallback={
                    <div
                      style={{
                        position: "absolute",
                        inset: 0,
                        background: `radial-gradient(circle at 50% 45%, ${accent}44, ${bg})`,
                      }}
                    />
                  }
                />
                {/* Warm gold tint over the photo */}
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    background: `linear-gradient(180deg, transparent 55%, ${accent}22 100%)`,
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div style={{ fontFamily: font, fontSize: 30, lineHeight: 1.05, fontWeight: 500, color: ink, letterSpacing: "0.04em" }}>
          {names}
        </div>

        {/* Tiny gold star row */}
        <div style={{ marginTop: "3%", display: "flex", gap: 6, alignItems: "center" }}>
          {[0, 1, 2].map((i) => (
            <span
              key={i}
              style={{
                width: i === 1 ? 5 : 3,
                height: i === 1 ? 5 : 3,
                background: accent,
                borderRadius: "50%",
                opacity: i === 1 ? 1 : 0.6,
              }}
            />
          ))}
        </div>

        <div style={{ flex: 1 }} />

        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6.5,
            fontWeight: 700,
            letterSpacing: "0.32em",
            color: accent,
            marginTop: "4%",
          }}
        >
          TO&apos;Y MAROSIMI · {date.toUpperCase()}
        </div>
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6,
            fontWeight: 600,
            letterSpacing: "0.28em",
            color: `${ink}99`,
            marginTop: 6,
          }}
        >
          {venue.toUpperCase()}
        </div>
      </div>
    </div>
  );
}
